import BybVrDialog from "@Components/game/common/dialog/byb-vr-dialog";
import FillingBrainIcon from "@Resources/app/icons-v2/system-icons/filling-brain-icon";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";

interface SessionResultsLoadingOverlayProps {
  open: boolean;
}

const SessionResultsLoadingOverlay = ({ open }: SessionResultsLoadingOverlayProps) => {
  const { i18n } = useI18n();

  return (
    <BybVrDialog name="session-results-loading" open={open} disableEscapeKeyDown>
      <Stack spacing={6} alignItems="center" padding={10}>
        <FillingBrainIcon size={160} loading loadingVariant="fill" loadingFillColor="white" loadingDuration="2.8s" showShadow={false} />
        <Typography variant="text3xl500" color="common.white" textAlign="center">
          {i18n("common.preparing-results")}
        </Typography>
      </Stack>
    </BybVrDialog>
  );
};

export default SessionResultsLoadingOverlay;
